module.exports = __webpack_public_path__ + "img/2.3ed1b4dc.jpg";